module.exports = __webpack_public_path__ + "static/media/f_eyeshape_monolid_blue.4671af41.png";